import React, { useState, useEffect, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Accordion, AccordionDetails, IconButton } from '@mui/material';
import { fieldTypes } from '@/helpers/constants';
import useWarningField from '@/hooks/useWarningField';
import { getCampaignChanges, getCampaignSearch } from '@/redux/Campaign/campaign.reducer';
import styles from './AccordionPanel.module.scss';
import MandatoryLabel from '../MandatoryLabel/MandatoryLabel';

interface AccordionPanelProps {
  id?: string;
  title: string | ReactNode;
  children: ReactNode;
  isMandatory?: boolean;
  invalid?: boolean;
  handleClick?: () => any;
  disabled?: boolean;
  removeTitle?: boolean;
  fieldPath?: string[];
  campaignChanges: any;
  additionalContentRight?: ReactNode;
  campaignSearch: any;
  headerCustomClass?: string;
  rightConentCustomClass?: string;
  tabsAccordion?: boolean;
  noExpandedButton?: boolean;
  bodyCustomClass?: string;
  isOpen?: boolean;
}

const AccordionPanel: React.FC<AccordionPanelProps> = (props) => {
  const { id, title, children, isMandatory = false, invalid = false, handleClick, disabled = false, removeTitle = false,
    fieldPath = [], campaignChanges, additionalContentRight, campaignSearch, headerCustomClass = '',
    rightConentCustomClass = '', tabsAccordion = false, noExpandedButton = false, bodyCustomClass, isOpen = true } = props;

  const inputTitle = isMandatory ? (<>{title} <MandatoryLabel /></>) : title;
  const warning = useWarningField(fieldPath, fieldTypes.ACCORDION) || invalid;
  const errorClass = warning ? 'error' : '';
  const [expanded, setExpanded] = useState(isOpen);

  useEffect(() => {
    if (campaignChanges?.active || campaignSearch?.active) setExpanded(true);
  }, [campaignChanges?.active, campaignSearch?.active]);

  return (
    <Accordion
      expanded={expanded}
      elevation={0}
      className={`${styles.Accordion} ${warning ? styles.AccordionError : ''}`}
      disabled={disabled}
      square
      defaultExpanded
      onClick={handleClick}
      data-testid={id}
    >
      <div className={`${removeTitle ? styles.NoTitle : styles.AccordionHeader} ${headerCustomClass}`}>
        <div className={`${styles.Title} ${errorClass}`}>{inputTitle}</div>
        <div className={`${styles.RightContent} ${rightConentCustomClass}`}>
          {additionalContentRight}
          {!noExpandedButton && (
            <IconButton data-testid={`${id}-expand-button`} size="small" onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}>
              {expanded && <i className={`di icon-pfeil-chevron-oben ${styles.Icon} `} />}
              {!expanded && <i className={`di icon-pfeil-chevron-unten ${styles.Icon} `} />}
            </IconButton>
          )}
        </div>
      </div>
      <AccordionDetails data-testid={`${id}-details`} className={`${tabsAccordion ? styles.TabsAccordion : styles.AccordionDetails} ${bodyCustomClass ? bodyCustomClass : ''}`}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

const mapStateToProps = (state) => ({
  campaignChanges: getCampaignChanges(state),
  campaignSearch: getCampaignSearch(state),
});

export default connect(mapStateToProps)(AccordionPanel);
